import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const [error, setError] = useState("");
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const run = async () => {
      try {
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.replace("#", "?")).get("session_id");
        if (!sessionId) throw new Error("Missing session");
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate("/app", { state: { user: data } });
      } catch (e) {
        const reason = e?.response?.data?.detail
          ? formatApiErrorDetail(e.response.data.detail)
          : (e?.message === "Missing session"
              ? "The sign-in redirect did not include a session token. Start again from the login page."
              : e?.code === "ERR_NETWORK"
                ? "Could not reach the Jobky server from this domain. If you run the site on a new domain, its address must be added to the server's allowed origins (CORS)."
                : "Could not reach the Jobky server. Check your connection and try again.");
        setError(reason);
      }
    };
    run();
  }, [navigate, setUser]);

  if (error) {
    return (
      <div className="grid min-h-screen place-items-center bg-bg p-6 text-center" data-testid="google-callback-error">
        <div>
          <p className="font-display text-2xl font-extrabold">Google sign-in did not complete</p>
          <p className="mt-2 text-sm text-muted">{error}</p>
          <a href="/login" className="mt-6 inline-block rounded-full bg-accent px-6 py-2.5 text-sm font-bold text-white">
            Back to login
          </a>
        </div>
      </div>
    );
  }
  return (
    <div className="grid min-h-screen place-items-center bg-bg" data-testid="google-callback-status">
      <p className="font-mono text-sm text-muted">Signing you in with Google…</p>
    </div>
  );
}
